import { useAuth0 } from '@auth0/auth0-react';
import { findRoles } from './filtering';
import { managerRoles } from '../constants/role-values';
import { namespace } from '../constants/text-values';

export const roleCheckerOtherEmployee = () => {
  const { user } = useAuth0();
  const managerRole = findRoles(
    user ? user[`${namespace}/roles`] : null,
    managerRoles,
  );
  return managerRole;
};
